<template>
  <div :style="{ width, height, margin, ...boxStyle }" class="boxBorder">
    <div :style="{ padding }" class="boxBorder_box">
      <div
        :class="childBoxClass"
        ref="contentDiv"
        :style="{
          'z-index': 2,
          position: 'relative',
          width: '100%',
          height: '100%',
          'box-sizing': 'border-box',
          'grid-template-columns': `repeat(${gridStyle.columnQuantity}, 1fr)`,
          'grid-template-rows': `repeat(${gridStyle.rowQuantity}, 1fr)`,
          'grid-row-gap': gridStyle.rowGap,
          'grid-column-gap': gridStyle.columnGap,
          ...childBoxStyle}"
      >
        <slot name="default"></slot>
      </div>
    </div>
    <span class="leftTop" v-if="spanShow"></span>
    <span class="rightTop" v-if="spanShow"></span>
    <span class="leftBottom" v-if="spanShow"></span>
    <span class="rightBottom" v-if="spanShow"></span>
    <span :style="titleStyle" class="topText" @click="setVnodeCom" v-show="titleShow">{{ title }}</span>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  name: 'BoxBorder',
  props: {
    spanShow: {
      type: Boolean,
      default: true
    },
    titleStyle: Object,
    boxStyle: Object,
    gridStyle: {
      type: Object,
      default () {
        return Object.create(null)
      }
    },
    childBoxClass: {
      type: Array,
      default () {
        return []
      }
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '100%',
    },
    title: {
      type: String,
    },
    padding: {
      type: String,
      default: '0.3rem 0.2rem 0.1rem 0.2rem'
    },
    margin: {
      type: String,
    },
    childBoxStyle: {
      type: Object,
      default: () => {
        return Object.create(null)
      },
    },
    titleShow: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    ...mapActions(['setPopSlot']),
    setVnodeCom(){
      if(this._self.$children?.[0]?.$refs?.tableThead){
        //表格
        const thead = this._self.$children[0].theadDatas;
        let hei = 85;
        for(let i = 0; i < thead.length; i++){
          hei -= 3;
        }
        this._self.$children[0].$options.propsData.height = hei + 'vh';
        Object.values(this._self.$slots).forEach((item) => {
          item.forEach(val => {
            val.data.ref = String(+new Date())
          })
        })
      }
      this.setPopSlot(this._self);
    }
  }
}
</script>
<style scoped>
.boxBorder {
  position: relative;
  display: flex;
  flex-direction: column-reverse;
  contain: size;
}
.boxBorder span {
  display: inline-block;
}
.boxBorder .boxBorder_box {
  height: 100%;
  width: 100%;
  border: 2px solid #1a3f81;
  box-sizing: border-box;
}
.boxBorder .leftTop,
.boxBorder .leftBottom,
.boxBorder .rightTop,
.boxBorder .rightBottom {
  position: absolute;
  background-color: #000a3b;
  background-repeat: no-repeat;
}
.boxBorder .leftTop,
.boxBorder .rightTop {
  top: 0;
}
.boxBorder .leftBottom,
.boxBorder .rightBottom {
  bottom: 0;
}
.boxBorder .leftTop,
.boxBorder .leftBottom {
  left: 0;
}
.boxBorder .rightTop,
.boxBorder .rightBottom {
  right: 0;
}
.leftTop {
  background-image: url('../assets/img/leftTop.png');
  width: 24px;
  height: 27px;
}
.leftBottom {
  background-image: url('../assets/img/leftBottom.png');
  width: 23px;
  height: 25px;
}
.rightTop {
  background-image: url('../assets/img/rightTop.png');
  width: 22px;
  height: 25px;
}
.rightBottom {
  background-image: url('../assets/img/rightBottom.png');
  width: 23px;
  height: 25px;
}
.boxBorder .topText {
  align-self: center;
  height: 0.39rem;
  min-width: 1.8rem;
  padding: 0 0.2rem;
  background: url('../assets/img/textBorder.png') no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.19rem;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #02d9fd;
  position: absolute;
  cursor: pointer;
  top: -0.18rem;
}
.flexWrap {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
</style>
